/**
 * Generic category filter.
 *
 * Looks for containers with [data-filter], which hold buttons with
 * [data-filter-value].  Filterable items are any element on the page
 * that carries a [data-categories] attribute (space-separated list of
 * slugs).
 *
 * Works for news, resources, and members — one filter group per page.
 */

export function initFilters() {
  const filterGroups = document.querySelectorAll("[data-filter]");
  if (filterGroups.length === 0) return;

  // Collect all filterable items on the page
  const items = Array.from(document.querySelectorAll("[data-categories]"));
  if (items.length === 0) return;

  filterGroups.forEach((group) => {
    const buttons = Array.from(
      group.querySelectorAll("[data-filter-value]")
    );
    if (buttons.length === 0) return;

    const applyFilter = (value) => {
      // Update button states
      buttons.forEach((btn) => {
        const isActive = btn.dataset.filterValue === value;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", String(isActive));
      });

      // Show / hide items
      items.forEach((item) => {
        const categories = (item.dataset.categories || "")
          .split(" ")
          .filter(Boolean);
        const show = value === "all" || categories.includes(value);
        item.classList.toggle("is-hidden", !show);
      });
    };

    // Delegate clicks on buttons
    group.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-filter-value]");
      if (!btn) return;
      applyFilter(btn.dataset.filterValue);
    });
  });
}
